import { render, staticRenderFns } from "./watch-button.vue?vue&type=template&id=67c56e00&lang=pug&"
import script from "./watch-button.vue?vue&type=script&lang=js&"
export * from "./watch-button.vue?vue&type=script&lang=js&"
import style0 from "./watch-button.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67c56e00')) {
      api.createRecord('67c56e00', component.options)
    } else {
      api.reload('67c56e00', component.options)
    }
    module.hot.accept("./watch-button.vue?vue&type=template&id=67c56e00&lang=pug&", function () {
      api.rerender('67c56e00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/watch-button.vue"
export default component.exports